import React, { Component } from "react"
import MetaTags from 'react-meta-tags'
import Sidebar from '../components/sidebar'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Jumbotron from 'react-bootstrap/Jumbotron'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import Table from 'react-bootstrap/Table'

class Rates extends Component {
    constructor(props) {
        super(props);
        this.state = {
            host: window.location.hostname,
            apihost: "https://www.emlakkatilim.com.tr"
        };
    }

    componentDidMount() {
        switch (window.location.hostname) {
            case "localhost":
                this.setState({ host: "http://localhost" });
                break;
            case "mortgagetest.emlakkatilim.com.tr":
                this.setState({ host: "https://mortgagetest.emlakkatilim.com.tr" });
                break;
            case "www.emlakkatilim.com.tr":
                this.setState({ host: "https://mortgage.emlakkatilim.com.tr" });
                break;
            default:
                this.setState({ host: "https://mortgage.emlakkatilim.com.tr" });
                break;
        }
    }

    render() {
        return (
            <>
                <MetaTags>
                    <title>Oranlarımız | Emlak Katılım Mortgage</title>
                    <meta name="robots" content="all" />
                    <meta name="description" content="Bireysel nakdi fon kullandırım fiyat listesi ve çapraz satış listesi ve indirim oranları..." />
                    <meta property="og:title" content="Oranlarımız | Emlak Katılım Mortgage" />
                    <meta property="og:type" content="website" />
                    <meta property="og:url" content="https://mortgage.emlakkatilim.com.tr/" />
                    <meta property="og:image" content="/content/images/seo/emlak-logo-facebook-size.jpg" />
                    <meta property="og:image:width" content="1200" />
                    <meta property="og:image:height" content="630" />
                    <meta property="og:description" content="Bireysel nakdi fon kullandırım fiyat listesi ve çapraz satış listesi ve indirim oranları..." />
                    <meta property="twitter:card" content="summary" />
                    <meta property="twitter:site" content="@tremlakkatilim" />
                    <meta property="twitter:title" content="Oranlarımız | Emlak Katılım Mortgage" />
                    <meta property="twitter:url" content={`${this.state.host}${this.props.location.pathname}`} />
                    <meta property="twitter:image" content={`${this.state.host}/content/images/seo/emlak-logo-twitter-size.jpg`} />
                    <meta property="twitter:description" content="Bireysel nakdi fon kullandırım fiyat listesi ve çapraz satış listesi ve indirim oranları..." />
                </MetaTags>
                <Jumbotron className="subpageHeader" fluid>
                    <Container>
                        <h1>Oranlarımız</h1>
                        <Breadcrumb>
                            <Breadcrumb.Item href="/">Ana Sayfa</Breadcrumb.Item>
                            <Breadcrumb.Item active>Oranlarımız</Breadcrumb.Item>
                        </Breadcrumb>
                    </Container>
                </Jumbotron>
                <Container>
                    <Row>
                        <Col className="subpageContent" sm={9}>
                            <div class="table-responsive">
                                <Table className="text-center mb-5" bordered hover size="md">
                                    <thead className="thead-light">
                                        <tr>
                                            <th colSpan="2">BİREYSEL NAKDİ FON KULLANDIRIM FİYAT LİSTESİ</th>
                                        </tr>
                                    </thead>
                                    <thead className="thead-dark">
                                        <tr>
                                            <th>TAKSİT SAYISI</th>
                                            <th>KONUT FİNANSMAN</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>12</td>
                                            <td>2.99</td>
                                        </tr>
                                        <tr>
                                            <td>24</td>
                                            <td>2.99</td>
                                        </tr>
                                        <tr>
                                            <td>36</td>
                                            <td>2.99</td>
                                        </tr>
                                        <tr>
                                            <td>48</td>
                                            <td>2.99</td>
                                        </tr>
                                        <tr>
                                            <td>60</td>
                                            <td>2.99</td>
                                        </tr>
                                        <tr>
                                            <td>72</td>
                                            <td>-</td>
                                        </tr>
                                        <tr>
                                            <td>84</td>
                                            <td>-</td>
                                        </tr>
                                        <tr>
                                            <td>96</td>
                                            <td>-</td>
                                        </tr>
                                        <tr>
                                            <td>108</td>
                                            <td>-</td>
                                        </tr>
                                        <tr>
                                            <td>120</td>
                                            <td>-</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                            <p>6306 Sayılı Kanun kapsamında hak sahiplerince bankalardan kullanılacak kredilere sağlanacak kar payı desteği tablosu aşağıda yer almaktadır:</p>
                            <div class='table-responsive'>
                                <Table className="text-center mb-5" bordered hover size="md">
                                    <thead className="thead-light">
                                        <tr>
                                            <th colSpan="6">KENTSEL DÖNÜŞÜM FİNANSMANI</th>
                                        </tr>
                                    </thead>
                                    <thead className="thead-dark">
                                        <tr>
                                            <th></th>
                                            <th>Finansman Türü</th>
                                            <th>Devlet Kar Payı Desteği (Yıllık)</th>
                                            <th>Azami Vade</th>
                                            <th>Devlet Kar Payı Desteği (Aylık)</th>
                                            <th>Finansman Üst Limiti</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>Güçlendirme Kredisi</td>
                                            <td>600 baz puan</td>
                                            <td>10 yıl</td>
                                            <td>%0,50</td>
                                            <td>320.000 TL</td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td>Konut Yapım Kredisi*</td>
                                            <td>840 baz puan</td>
                                            <td>10 yıl</td>
                                            <td>%0,70</td>
                                            <td>1.250.000 TL</td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>Konut Edinme Kredisi</td>
                                            <td>840 baz puan</td>
                                            <td>10 yıl</td>
                                            <td>%0,70</td>
                                            <td>1.250.000 TL</td>
                                        </tr>
                                        <tr>
                                            <td>4</td>
                                            <td>İşyeri Yapım Kredisi</td>
                                            <td>480 baz puan</td>
                                            <td>7 Yıl</td>
                                            <td>%0,40</td>
                                            <td>800.000 TL</td>
                                        </tr>
                                        <tr>
                                            <td>5</td>
                                            <td>İşyeri Edinme Kredisi</td>
                                            <td>480 baz puan</td>
                                            <td>7 Yıl</td>
                                            <td>%0,40</td>
                                            <td>350.000 TL</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                            <p>* Sadece Konut Yapım Finansmanı İşlemlerinde İlk konut için; 840 baz puan devlet desteği sağlanacaktır. Daha sonra ki kentsel dönüşüme girecek konutlar için en fazla 3 milyon TL’ye kadar 720 baz puan devlet desteği uygulanacaktır.</p>
                        </Col>
                        <Col sm={3}>
                            <Sidebar />
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }
}

export default Rates;